import React, { Component } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { connect } from "react-redux";
import { dismissDialog, confirmPendingAction } from "./DialogAction";
import { Colors } from "config/StyleConfig";
import withStyles from '@mui/styles/withStyles';
import { DIALOG_BOX_TYPE } from "./DialogTypes";

const styles = {
  button: {
    color: Colors.primary,
  },
};

class DialogBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: this.props.open,
      title: this.props.title,
      description: this.props.description,
      dialogType: this.props.dialogType,
      pendingAction: this.props.pendingAction,
    };
  }

  render() {
    const { classes } = this.props;

    const actions = [];
    if (this.props.dialogType === DIALOG_BOX_TYPE.ACCEPT_CANCEL_DIALOG) {
      actions.push(
        <Button key="confirm" onClick={() => this.props.confirmPendingAction()} className={classes.button}>
          Confirm
        </Button>
      );
      actions.push(
        <Button key="cancel" onClick={() => this.props.dismissDialog()} className={classes.button}>
          Cancel
        </Button>
      );
    } else {
      actions.push(
        <Button key="dismiss" onClick={() => this.props.dismissDialog()} className={classes.button}>
          Dismiss
        </Button>
      );
    }

    return (
      <Dialog
        open={this.props.open}
        onClose={() => this.props.dismissDialog()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ zIndex: 9001 }}
      >
        <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{this.props.description}</DialogContentText>
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    open: state.DialogReducer.open,
    title: state.DialogReducer.title,
    description: state.DialogReducer.description,
    dialogType: state.DialogReducer.dialogType,
    pendingAction: state.DialogReducer.pendingAction,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dismissDialog: () => dispatch(dismissDialog()),
    confirmPendingAction: () => dispatch(confirmPendingAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DialogBox));
